var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadingStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0L36.5761 23.4239L60 30L36.5761 36.5761L30 60L23.4239 36.5761L0 30L23.4239 23.4239L30 0Z",
    fill: "#0047FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingStar);
export default __webpack_public_path__ + "static/media/loadingStar.ada1db4341af34dd9c061a37fe6c04b5.svg";
export { ForwardRef as ReactComponent };